import React from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import useAuth from "hooks/useAuth";

const FinanceGuard = ({ children }) => {
  const { user, isLoggedIn } = useAuth();

  if (isLoggedIn && user && user.canViewFinance === false) {
    return <Navigate to="/dashboard/default" replace />;
  }

  return children;
};

FinanceGuard.propTypes = {
  children: PropTypes.node,
};

export default FinanceGuard;
